import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { BRANDS, NAV, COMPANY } from "@/data/content";
import { useLenis, scrollToId } from "@/lib/lenis";

export const Footer = () => {
  const lenis = useLenis();
  return (
    <footer data-testid="footer" className="border-t border-white/10 bg-brand-navy pb-10 pt-20 text-white">
      <div className="mx-auto grid max-w-[1400px] gap-12 px-6 lg:grid-cols-12 lg:px-10">
        <div className="lg:col-span-5">
          <Logo dark size={44} testId="footer-logo" />
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-white/55">
            Precision outsourcing, human at the core, built in India. The company behind Artwork 360 and Medlyn 360.
          </p>
        </div>
        <div className="lg:col-span-2">
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-brand-cyan">Company</div>
          <ul className="mt-5 space-y-3 text-sm">
            {NAV.map((n) => (
              <li key={n.id}><button data-testid={`footer-link-${n.id}`} onClick={() => scrollToId(lenis, n.id)} className="link-underline text-white/70 hover:text-white">{n.label}</button></li>
            ))}
            <li><Link data-testid="footer-link-careers" to="/careers" className="link-underline text-white/70 hover:text-white">Careers</Link></li>
          </ul>
        </div>
        <div className="lg:col-span-2">
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-brand-cyan">Brands</div>
          <ul className="mt-5 space-y-3 text-sm">
            {BRANDS.map((b) => (
              <li key={b.id}><a data-testid={`footer-brand-${b.id}`} href={b.url} target="_blank" rel="noreferrer" className="link-underline text-white/70 hover:text-white">{b.name}</a></li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-3">
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-brand-cyan">Registered office</div>
          <p data-testid="footer-address-text" className="mt-5 text-sm leading-relaxed text-white/70">{COMPANY.address}</p>
          <p className="mt-3 text-sm text-white/70"><a href={`mailto:${COMPANY.email}`} className="link-underline">{COMPANY.email}</a> · <a href={COMPANY.phoneHref} className="link-underline">{COMPANY.phone}</a></p>
          <p className="mt-3 font-mono text-[11px] text-white/40">{COMPANY.cin}</p>
        </div>
      </div>
      <div className="mx-auto mt-16 flex max-w-[1400px] flex-wrap items-center justify-between gap-4 border-t border-white/10 px-6 pt-8 font-mono text-[10px] uppercase tracking-[0.2em] text-white/40 lg:px-10">
        <span data-testid="footer-copyright">© {new Date().getFullYear()} {COMPANY.name}. All rights reserved.</span>
        <span>Mumbai, IN → USA</span>
        <span className="flex items-center gap-5">
          {COMPANY.linkedin && <a data-testid="footer-linkedin" href={COMPANY.linkedin} target="_blank" rel="noreferrer" className="link-underline hover:text-white">LinkedIn</a>}
          <Link data-testid="footer-brand-kit-link" to="/brand" className="link-underline hover:text-white">Brand assets</Link>
          <Link data-testid="footer-admin-link" to="/admin" className="link-underline hover:text-white">Admin</Link>
        </span>
      </div>
    </footer>
  );
};
